<template>
  <div v-if="!loadingState" class="d-flex flex-column h-100">
    <navigation-top/>

    <div v-if="starredWorkflows?.length > 0" style="margin-top: 38px; margin-bottom: 24px;">
      <div class="d-flex justify-space-between" style="margin-bottom: 18px;">
        <span>Starred Workflows</span>
        <sort-dropdown
          :items="workflowSortingOptions"
          :default-value="starredSortBy"
          @onSelect="starredSortBy = $event"
        />
      </div>
      <div class="dashboard-grid-layout">
        <dashboard-workflow-card
          v-for="workflow in starredWorkflows"
          :key="workflow.id"
          :workflow="{ ...workflow, projectName: project?.name, organisationName: project?.organisation?.name }"
          @edit="editWorkflow"
        ></dashboard-workflow-card>
      </div>
    </div>

    <div style="margin-top: 38px; margin-bottom: 24px;">
      <div class="d-flex justify-space-between" style="margin-bottom: 18px;">
        <span>{{ starredWorkflows?.length > 0 ? 'Other workflows' : 'All Workflows' }}</span>
        <sort-dropdown
          :items="workflowSortingOptions"
          :default-value="workflowsSortBy"
          @onSelect="workflowsSortBy = $event"
        />
      </div>
      <div class="dashboard-grid-layout">
        <workflow-dialog ref="dialogWorkflow" :setWorkflow="true" v-if="subscriptionAccessType === 'FULL'">
          <template #activator="{ props }">
            <div v-bind="props" class="dashboard-card text-new-button d-flex flex-column justify-center align-center">
              <v-icon style="font-size: 40px;" class="mb-2">mds:add</v-icon>
              New Workflow
            </div>
          </template>
        </workflow-dialog>

        <dashboard-workflow-card
          v-for="workflow in notStarredWorkflows"
          :key="workflow.id"
          :hide-actions="subscriptionAccessType !== 'FULL'"
          :workflow="{ ...workflow, projectName: project?.name, organisationName: project?.organisation?.name }"
          @edit="editWorkflow"
        ></dashboard-workflow-card>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import SortDropdown from '@/components/SortDropdown'
import NavigationTop from '@/components/NavigationTop'
import WorkflowDialog from '@/components/WorkflowDialog'
import DashboardWorkflowCard from '@/components/DashboardWorkflowCard'
import { readStorage, writeStorage } from '@/utils/storage'

const WORKFLOWS_SORT_STORAGE_KEY = 'qlerify.project.workflowsSortBy'
const STARRED_SORT_STORAGE_KEY = 'qlerify.project.starredSortBy'

export default {
  components: {
    WorkflowDialog,
    DashboardWorkflowCard,
    NavigationTop,
    SortDropdown
  },
  data () {
    return {
      workflowsSortBy: readStorage(WORKFLOWS_SORT_STORAGE_KEY, 'last_modified'),
      starredSortBy: readStorage(STARRED_SORT_STORAGE_KEY, 'last_modified'),
      workflowSortingOptions: [
        { title: 'Last modified', value: 'last_modified' },
        { title: 'Name', value: 'name' }
      ]
    }
  },
  computed: {
    ...mapState({
      workflows: state => state.workflows.workflows,
      subscriptionAccessType: state => state.payments.subscriptionAccessType
    }),
    ...mapGetters({
      project: 'projectMemberships/activeProject',
      loadingState: 'loading/getLoadingState'
    }),
    starredWorkflows () {
      const res = (this.workflows || []).filter(workflow => workflow.starred)
      return this.applySort(res, this.starredSortBy)
    },
    notStarredWorkflows () {
      const res = (this.workflows || []).filter(workflow => !workflow.starred)
      return this.applySort(res, this.workflowsSortBy)
    }
  },

  watch: {
    workflowsSortBy (val) {
      writeStorage(WORKFLOWS_SORT_STORAGE_KEY, val)
    },
    starredSortBy (val) {
      writeStorage(STARRED_SORT_STORAGE_KEY, val)
    }
  },

  methods: {
    applySort (workflows, sortBy) {
      const list = [...(workflows || [])]
      if (sortBy === 'name') {
        return list.sort((a, b) => (a.name || '').localeCompare(b.name || ''))
      }
      return list.sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt))
    },

    editWorkflow (item) {
      this.$refs.dialogWorkflow.setItem(Object.assign({}, item))
      this.$refs.dialogWorkflow.openWorkflowDialog()
    }
  }
}
</script>
